const ROLE_PERMISSIONS = {
    admin: "*",
    "recipe-manager": [
        "recipes",
        "products",
        "ingredients",
        "generate-recipes",
        "tags",
        "situational-ratings",
        "catalog-health",
    ],
};
export function hasAccess(role, resource) {
    if (!role) {
        return false;
    }
    const permissions = ROLE_PERMISSIONS[role];
    if (!permissions) {
        return false;
    }
    if (permissions === "*") {
        return true;
    }
    return permissions.includes(resource);
}
export function getFirstAllowedPath(role) {
    if (!role) {
        return "/login";
    }
    const permissions = ROLE_PERMISSIONS[role];
    if (!permissions) {
        return "/login";
    }
    if (permissions === "*") {
        return "/recipes";
    }
    if (permissions.includes("recipes")) {
        return "/recipes";
    }
    return `/${permissions[0]}`;
}
